import { UserPlanVo, UserProfile } from "@/api";
import LogoutIcon from "@/assets/icons/logout.svg";
import defaultAvatar from "@/assets/images/default-avatar.jpg";
import { VidMuseEvent } from "@/common/events";
import { logger } from "@/common/logger";
import { Button } from "@/component/Button";
import { Avatar, Popover } from "antd";
import classNames from "classnames";
import Link from "next/link";
import React from "react";
import styles from "../index.module.css";

interface UserPopoverProps {
  user: UserProfile;
  userPlan: UserPlanVo | null;
  feedbackUrl: string;
}

export const UserPopover: React.FC<UserPopoverProps> = ({
  user,
  userPlan,
  feedbackUrl,
}) => (
  <Popover
    key="user-popover"
    trigger={["hover"]}
    placement="bottom"
    arrow={false}
    classNames={{
      root: "!pr-0 sm:!pr-8 !pt-1",
      body: classNames(
        "!p-2 flex bg-background-card! text-xs text-center !rounded-xl",
        styles.popoverBody
      ),
    }}
    zIndex={100}
    content={
      <>
        <div className="text-text-primary font-normal p-4 rounded-lg bg-background-elevated w-[240px] sm:w-[260px]">
          <div className="flex items-center justify-between">
            <div className="flex flex-col items-start w-[180px] sm:w-[230px]">
              <strong className="text-sm font-medium truncate block">
                {user.nickname}
              </strong>

              <p className="text-xs text-graphite truncate block">
                {user.email}
              </p>
            </div>
          </div>

          <div
            className="w-full h-px mt-3 mb-2 opacity-40"
            style={{
              backgroundImage: "url(/dash-line.svg)",
              backgroundRepeat: "repeat-x",
            }}
          ></div>

          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col items-start">
              <p
                className={classNames(
                  "font-medium",
                  userPlan?.expireTime ? "text-sm" : "text-base"
                )}
              >
                {userPlan?.memberShipName}
              </p>

              {userPlan?.expireTime && (
                <p className="text-xs text-graphite">
                  Valid until:{" "}
                  {new Date(userPlan.expireTime).toLocaleDateString()}
                </p>
              )}
            </div>

            <Link href="/pricing" data-disable-progress={true}>
              <Button
                type="primary"
                className="!h-7 !px-3 !text-xs"
                onClick={() => {
                  logger.event(VidMuseEvent.HeaderMenuClick, {
                    menu: "user",
                    item: "upgrade",
                  });
                }}
              >
                Upgrade
              </Button>
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-2 mt-2">
          {/* <Link href={feedbackUrl} target="_blank" className="w-full h-12">
            <Button
              type="plain"
              className="w-full h-full justify-start rounded-lg pl-4 text-text-primary font-normal hover:bg-background-card-hover"
              icon={<ProblemFeedbackIcon className="w-6 h-6" />}
              onClick={() => {
                logger.event(VidMuseEvent.HeaderMenuClick, {
                  menu: "user",
                  item: "feedback",
                });
              }}
            >
              Feedback & Suggestion
            </Button>
          </Link> */}
          <Button
            type="plain"
            className="w-full justify-start h-12 rounded-lg pl-4 text-text-primary font-normal hover:bg-background-card-hover"
            icon={<LogoutIcon className="w-6 h-6" />}
            onClick={() => {
              logger.event(VidMuseEvent.HeaderMenuClick, {
                menu: "user",
                item: "logout",
              });
              window.location.href = "/auth/logout";
            }}
          >
            Logout
          </Button>
        </div>
      </>
    }
  >
    <Avatar
      src={user.avatarUrl || defaultAvatar.src}
      className="rounded-full cursor-pointer !w-9 !h-9 sm:!w-10 sm:!h-10"
    />
  </Popover>
);
